import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { MANAGE_PROFILE_SAVE } from './url-constants';

type ManageProfileSaveEndpointSpecification = ApiEndpointSpecification;
export const ManageProfileSaveEndpointSpecification: ManageProfileSaveEndpointSpecification = {
    url: MANAGE_PROFILE_SAVE,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'ManageProfileSaveRequestParams',
    requestBodySchemaName: 'ManageProfileSaveRequestBody',
    okResponseSchemaName: 'ManageProfileSaveOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:3
};

export const invokeManageProfileSave = Helpers.makeApiRequestFn<
    Types.ManageProfileSaveRequestParams,
    Types.ManageProfileSaveRequestBody,
    Types.ManageProfileSaveOkResponse
>(ManageProfileSaveEndpointSpecification);
